import { SelectItem } from '../../main/components'

export type BubbleSelectOption = SelectItem<string> & { format?: string }

export const ETF_MARKET_CAP_LABEL = '3-month average dollar volume'

var xys = [
  { value: 'sector', label: 'Sector' },
  { value: 'ticker', label: 'Ticker' },
  { value: 'order', label: 'Order' },
  { value: 'marketCap', label: 'Market Capitalization' },
  { value: 'dividendYield', label: 'Dividend Yield', format: '%' },
  { value: 'payoutRatio', label: 'Payout Ratio', format: '%' },
  { value: 'employees', label: 'Employees' },
  { value: 'income', label: 'Income' },
  { value: 'sales', label: 'Sales' },
  { value: 'epsQoQ', label: 'EPS growth Q/Q', format: '%' },
  { value: 'epsYoY', label: 'EPS growth this Y/Y', format: '%' },
  { value: 'epsYoY1', label: 'EPS growth next Y/Y', format: '%' },
  { value: 'eps5Years', label: 'EPS growth past 5 years', format: '%' },
  { value: 'estLTGrowth', label: 'EPS growth long term est.', format: '%' },
  { value: 'salesQoQ', label: 'Sales growth Q/Q', format: '%' },
  { value: 'sales5Years', label: 'Sales growth past 5 years', format: '%' },
  { value: 'PE', label: 'P/E' },
  { value: 'forwardPE', label: 'Forward P/E' },
  { value: 'PEG', label: 'PEG' },
  { value: 'PS', label: 'P/S' },
  { value: 'PB', label: 'P/B' },
  { value: 'PC', label: 'P/C' },
  { value: 'PFCF', label: 'P/FCF' },
  { value: 'roi', label: 'ROI' },
  { value: 'roe', label: 'ROE' },
  { value: 'roa', label: 'ROA' },
  { value: 'grossMargin', label: 'Gross Margin', format: '%' },
  { value: 'operMargin', label: 'Operating Margin', format: '%' },
  { value: 'netMargin', label: 'Profit Margin', format: '%' },
  { value: 'curRatio', label: 'Current Ratio' },
  { value: 'quickRatio', label: 'Quick Ratio' },
  { value: 'ltdebtEq', label: 'Long Term Debt to Equity' },
  { value: 'debtEq', label: 'Total Debt to Equity' },
  { value: 'lastChange', label: 'Change', format: '%' },
  { value: 'changeOpen', label: 'Change from Open', format: '%' },
  { value: 'gap', label: 'Gap', format: '%' },
  { value: 'lastVolume', label: 'Volume' },
  { value: 'lastVolumeUsd', label: 'Volume USD' },
  { value: 'averageVolume', label: 'Average Volume' },
  { value: 'averageVolumeUsd', label: 'Average Volume USD' },
  { value: 'relativeVolume', label: 'Relative Volume' },
  { value: 'perf1w', label: '1 Week Performance', format: '%' },
  { value: 'perf4w', label: '1 Month Performance', format: '%' },
  { value: 'perf13w', label: '3 Month Performance', format: '%' },
  { value: 'perf26w', label: '6 Month Performance', format: '%' },
  { value: 'perf52w', label: '1 Year Performance', format: '%' },
  { value: 'perfYtd', label: 'Year To Date Performance', format: '%' },
  { value: 'volatility1w', label: 'Weekly Volatility', format: '%' },
  { value: 'volatility4w', label: 'Monthly Volatlity', format: '%' },
  { value: 'beta', label: 'Beta' },
  { value: 'low52w', label: '52-Week Low', format: '%' },
  { value: 'high52w', label: '52-Week High', format: '%' },
  { value: 'sma20', label: 'Simple Moving Average 20', format: '%' },
  { value: 'sma50', label: 'Simple Moving Average 50', format: '%' },
  { value: 'sma200', label: 'Simple Moving Average 200', format: '%' },
  { value: 'rsi', label: 'Relative Strength Index 14' },
  { value: 'insiderOwn', label: 'Insider Ownership', format: '%' },
  { value: 'insiderTrans', label: 'Insider Transactions', format: '%' },
  { value: 'instOwn', label: 'Institutional Ownership', format: '%' },
  { value: 'instTrans', label: 'Institutional Transactions', format: '%' },
  { value: 'shortInterestShare', label: 'Short Interest Share', format: '%' },
  { value: 'shortInterestRatio', label: 'Short Interest Ratio' },
  { value: 'consRecom', label: 'Analyst Recommendation' },
  { value: 'targetPrice', label: 'Target Price', format: '%' },
]

var sizes = [
  { value: 'const', label: 'Constant' },
  { value: 'marketCap', label: 'Market Capitalization' },
  { value: 'lastVolume', label: 'Volume' },
  { value: 'lastVolumeUsd', label: 'Volume USD' },
  { value: 'averageVolume', label: 'Average Volume' },
  { value: 'averageVolumeUsd', label: 'Average Volume USD' },
  { value: 'relativeVolume', label: 'Relative Volume' },
]

var colors = [
  { value: 'const', label: 'Constant' },
  { value: 'sector', label: 'Sector' },
  { value: 'industry', label: 'Industry' },
  { value: 'country', label: 'Country' },
  { value: 'marketCap', label: 'Market Capitalization' },
  { value: 'lastChange', label: 'Change', format: '%' },
  { value: 'perf1w', label: '1 Week Performance', format: '%' },
  { value: 'perf4w', label: '1 Month Performance', format: '%' },
  { value: 'perf13w', label: '3 Month Performance', format: '%' },
  { value: 'perf26w', label: '6 Month Performance', format: '%' },
  { value: 'perf52w', label: '1 Year Performance', format: '%' },
  { value: 'perfYtd', label: 'Year To Date Performance', format: '%' },
  { value: 'lastVolume', label: 'Volume' },
  { value: 'lastVolumeUsd', label: 'Volume USD' },
  { value: 'averageVolume', label: 'Average Volume' },
  { value: 'averageVolumeUsd', label: 'Average Volume USD' },
  { value: 'relativeVolume', label: 'Relative Volume' },
  { value: 'consRecom', label: 'Analyst Recommendation' },
]

var indexes = [
  { value: 'any', label: 'Any' },
  { value: 'sp500', label: 'S&P 500' },
  { value: 'ndx', label: 'NASDAQ 100' },
  { value: 'dji', label: 'DJIA' },
  { value: 'rut', label: 'RUSSELL 2000' },
]

var sectors = [
  { value: '', label: 'Any' },
  { value: 'basicmaterials', label: 'Basic Materials' },
  { value: 'communicationservices', label: 'Communication Services' },
  { value: 'consumercyclical', label: 'Consumer Cyclical' },
  { value: 'consumerdefensive', label: 'Consumer Defensive' },
  { value: 'energy', label: 'Energy' },
  { value: 'financial', label: 'Financial' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'industrials', label: 'Industrials' },
  { value: 'realestate', label: 'Real Estate' },
  { value: 'technology', label: 'Technology' },
  { value: 'utilities', label: 'Utilities' },
]

var industries = [
  { value: '', label: 'Any' },
  { value: 'stocksonly', label: 'Stocks only (ex-Funds)' },
  { value: 'exchangetradedfund', label: 'Exchange Traded Fund' },
  { value: 'advertisingagencies', label: 'Advertising Agencies' },
  { value: 'aerospacedefense', label: 'Aerospace & Defense' },
  { value: 'agriculturalinputs', label: 'Agricultural Inputs' },
  { value: 'airlines', label: 'Airlines' },
  { value: 'airportsairservices', label: 'Airports & Air Services' },
  { value: 'aluminum', label: 'Aluminum' },
  { value: 'apparelmanufacturing', label: 'Apparel Manufacturing' },
  { value: 'apparelretail', label: 'Apparel Retail' },
  { value: 'assetmanagement', label: 'Asset Management' },
  { value: 'automanufacturers', label: 'Auto Manufacturers' },
  { value: 'autoparts', label: 'Auto Parts' },
  { value: 'autotruckdealerships', label: 'Auto & Truck Dealerships' },
  { value: 'banksdiversified', label: 'Banks - Diversified' },
  { value: 'banksregional', label: 'Banks - Regional' },
  { value: 'beveragesbrewers', label: 'Beverages - Brewers' },
  { value: 'beveragesnonalcoholic', label: 'Beverages - Non-Alcoholic' },
  { value: 'beverageswineriesdistilleries', label: 'Beverages - Wineries & Distilleries' },
  { value: 'biotechnology', label: 'Biotechnology' },
  { value: 'broadcasting', label: 'Broadcasting' },
  { value: 'buildingmaterials', label: 'Building Materials' },
  { value: 'buildingproductsequipment', label: 'Building Products & Equipment' },
  { value: 'businessequipmentsupplies', label: 'Business Equipment & Supplies' },
  { value: 'capitalmarkets', label: 'Capital Markets' },
  { value: 'chemicals', label: 'Chemicals' },
  { value: 'closedendfunddebt', label: 'Closed-End Fund - Debt' },
  { value: 'closedendfundequity', label: 'Closed-End Fund - Equity' },
  { value: 'closedendfundforeign', label: 'Closed-End Fund - Foreign' },
  { value: 'cokingcoal', label: 'Coking Coal' },
  { value: 'communicationequipment', label: 'Communication Equipment' },
  { value: 'computerhardware', label: 'Computer Hardware' },
  { value: 'confectioners', label: 'Confectioners' },
  { value: 'conglomerates', label: 'Conglomerates' },
  { value: 'consultingservices', label: 'Consulting Services' },
  { value: 'consumerelectronics', label: 'Consumer Electronics' },
  { value: 'copper', label: 'Copper' },
  { value: 'creditservices', label: 'Credit Services' },
  { value: 'departmentstores', label: 'Department Stores' },
  { value: 'diagnosticsresearch', label: 'Diagnostics & Research' },
  { value: 'discountstores', label: 'Discount Stores' },
  { value: 'drugmanufacturersgeneral', label: 'Drug Manufacturers - General' },
  { value: 'drugmanufacturersspecialtygeneric', label: 'Drug Manufacturers - Specialty & Generic' },
  { value: 'educationtrainingservices', label: 'Education & Training Services' },
  { value: 'electricalequipmentparts', label: 'Electrical Equipment & Parts' },
  { value: 'electroniccomponents', label: 'Electronic Components' },
  { value: 'electronicgamingmultimedia', label: 'Electronic Gaming & Multimedia' },
  { value: 'electronicscomputerdistribution', label: 'Electronics & Computer Distribution' },
  { value: 'engineeringconstruction', label: 'Engineering & Construction' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'farmheavyconstructionmachinery', label: 'Farm & Heavy Construction Machinery' },
  { value: 'farmproducts', label: 'Farm Products' },
  { value: 'financialconglomerates', label: 'Financial Conglomerates' },
  { value: 'financialdatastockexchanges', label: 'Financial Data & Stock Exchanges' },
  { value: 'fooddistribution', label: 'Food Distribution' },
  { value: 'footwearaccessories', label: 'Footwear & Accessories' },
  { value: 'furnishingsfixturesappliances', label: 'Furnishings, Fixtures & Appliances' },
  { value: 'gambling', label: 'Gambling' },
  { value: 'gold', label: 'Gold' },
  { value: 'grocerystores', label: 'Grocery Stores' },
  { value: 'healthcareplans', label: 'Healthcare Plans' },
  { value: 'healthinformationservices', label: 'Health Information Services' },
  { value: 'homeimprovementretail', label: 'Home Improvement Retail' },
  { value: 'householdpersonalproducts', label: 'Household & Personal Products' },
  { value: 'industrialdistribution', label: 'Industrial Distribution' },
  { value: 'informationtechnologyservices', label: 'Information Technology Services' },
  { value: 'infrastructureoperations', label: 'Infrastructure Operations' },
  { value: 'insurancebrokers', label: 'Insurance Brokers' },
  { value: 'insurancediversified', label: 'Insurance - Diversified' },
  { value: 'insurancelife', label: 'Insurance - Life' },
  { value: 'insurancepropertycasualty', label: 'Insurance - Property & Casualty' },
  { value: 'insurancereinsurance', label: 'Insurance - Reinsurance' },
  { value: 'insurancespecialty', label: 'Insurance - Specialty' },
  { value: 'integratedfreightlogistics', label: 'Integrated Freight & Logistics' },
  { value: 'internetcontentinformation', label: 'Internet Content & Information' },
  { value: 'internetretail', label: 'Internet Retail' },
  { value: 'leisure', label: 'Leisure' },
  { value: 'lodging', label: 'Lodging' },
  { value: 'lumberwoodproduction', label: 'Lumber & Wood Production' },
  { value: 'luxurygoods', label: 'Luxury Goods' },
  { value: 'marineshipping', label: 'Marine Shipping' },
  { value: 'medicalcarefacilities', label: 'Medical Care Facilities' },
  { value: 'medicaldevices', label: 'Medical Devices' },
  { value: 'medicaldistribution', label: 'Medical Distribution' },
  { value: 'medicalinstrumentssupplies', label: 'Medical Instruments & Supplies' },
  { value: 'metalfabrication', label: 'Metal Fabrication' },
  { value: 'mortgagefinance', label: 'Mortgage Finance' },
  { value: 'oilgasdrilling', label: 'Oil & Gas Drilling' },
  { value: 'oilgasep', label: 'Oil & Gas E&P' },
  { value: 'oilgasequipmentservices', label: 'Oil & Gas Equipment & Services' },
  { value: 'oilgasintegrated', label: 'Oil & Gas Integrated' },
  { value: 'oilgasmidstream', label: 'Oil & Gas Midstream' },
  { value: 'oilgasrefiningmarketing', label: 'Oil & Gas Refining & Marketing' },
  { value: 'otherindustrialmetalsmining', label: 'Other Industrial Metals & Mining' },
  { value: 'otherpreciousmetalsmining', label: 'Other Precious Metals & Mining' },
  { value: 'packagedfoods', label: 'Packaged Foods' },
  { value: 'packagingcontainers', label: 'Packaging & Containers' },
  { value: 'paperpaperproducts', label: 'Paper & Paper Products' },
  { value: 'personalservices', label: 'Personal Services' },
  { value: 'pharmaceuticalretailers', label: 'Pharmaceutical Retailers' },
  { value: 'pollutiontreatmentcontrols', label: 'Pollution & Treatment Controls' },
  { value: 'publishing', label: 'Publishing' },
  { value: 'railroads', label: 'Railroads' },
  { value: 'realestatedevelopment', label: 'Real Estate - Development' },
  { value: 'realestatediversified', label: 'Real Estate - Diversified' },
  { value: 'realestateservices', label: 'Real Estate Services' },
  { value: 'recreationalvehicles', label: 'Recreational Vehicles' },
  { value: 'reitdiversified', label: 'REIT - Diversified' },
  { value: 'reithealthcarefacilities', label: 'REIT - Healthcare Facilities' },
  { value: 'reithotelmotel', label: 'REIT - Hotel & Motel' },
  { value: 'reitindustrial', label: 'REIT - Industrial' },
  { value: 'reitmortgage', label: 'REIT - Mortgage' },
  { value: 'reitoffice', label: 'REIT - Office' },
  { value: 'reitresidential', label: 'REIT - Residential' },
  { value: 'reitretail', label: 'REIT - Retail' },
  { value: 'reitspecialty', label: 'REIT - Specialty' },
  { value: 'rentalleasingservices', label: 'Rental & Leasing Services' },
  { value: 'residentialconstruction', label: 'Residential Construction' },
  { value: 'resortscasinos', label: 'Resorts & Casinos' },
  { value: 'restaurants', label: 'Restaurants' },
  { value: 'scientifictechnicalinstruments', label: 'Scientific & Technical Instruments' },
  { value: 'securityprotectionservices', label: 'Security & Protection Services' },
  { value: 'semiconductorequipmentmaterials', label: 'Semiconductor Equipment & Materials' },
  { value: 'semiconductors', label: 'Semiconductors' },
  { value: 'shellcompanies', label: 'Shell Companies' },
  { value: 'silver', label: 'Silver' },
  { value: 'softwareapplication', label: 'Software - Application' },
  { value: 'softwareinfrastructure', label: 'Software - Infrastructure' },
  { value: 'solar', label: 'Solar' },
  { value: 'specialtybusinessservices', label: 'Specialty Business Services' },
  { value: 'specialtychemicals', label: 'Specialty Chemicals' },
  { value: 'specialtyindustrialmachinery', label: 'Specialty Industrial Machinery' },
  { value: 'specialtyretail', label: 'Specialty Retail' },
  { value: 'staffingemploymentservices', label: 'Staffing & Employment Services' },
  { value: 'steel', label: 'Steel' },
  { value: 'telecomservices', label: 'Telecom Services' },
  { value: 'textilemanufacturing', label: 'Textile Manufacturing' },
  { value: 'thermalcoal', label: 'Thermal Coal' },
  { value: 'tobacco', label: 'Tobacco' },
  { value: 'toolsaccessories', label: 'Tools & Accessories' },
  { value: 'travelservices', label: 'Travel Services' },
  { value: 'trucking', label: 'Trucking' },
  { value: 'uranium', label: 'Uranium' },
  { value: 'utilitiesdiversified', label: 'Utilities - Diversified' },
  { value: 'utilitiesindependentpowerproducers', label: 'Utilities - Independent Power Producers' },
  { value: 'utilitiesregulatedelectric', label: 'Utilities - Regulated Electric' },
  { value: 'utilitiesregulatedgas', label: 'Utilities - Regulated Gas' },
  { value: 'utilitiesregulatedwater', label: 'Utilities - Regulated Water' },
  { value: 'utilitiesrenewable', label: 'Utilities - Renewable' },
  { value: 'wastemanagement', label: 'Waste Management' },
]

var marketCaps = [
  { value: '', label: 'Any' },
  { value: 'mega', label: 'Mega ($200bln and more)' },
  { value: 'large', label: 'Large ($10bln to $200bln)' },
  { value: 'mid', label: 'Mid ($2bln to $10bln)' },
  { value: 'small', label: 'Small ($300mln to $2bln)' },
  { value: 'micro', label: 'Micro ($50mln to $300mln)' },
  { value: 'nano', label: 'Nano (under $50mln)' },
  { value: 'largeover', label: '+Large (over $10bln)' },
  { value: 'midover', label: '+Mid (over $2bln)' },
  { value: 'smallover', label: '+Small (over $300mln)' },
  { value: 'microover', label: '+Micro (over $50mln)' },
  { value: 'largeunder', label: '-Large (under $200bln)' },
  { value: 'midunder', label: '-Mid (under $10bln)' },
  { value: 'smallunder', label: '-Small (under $2bln)' },
  { value: 'microunder', label: '-Micro (under $300mln)' },
]

var averageVolumes = [
  { value: '', label: 'Any' },
  { value: 'u50', label: 'Under 50K' },
  { value: 'u100', label: 'Under 100K' },
  { value: 'u500', label: 'Under 500K' },
  { value: 'u750', label: 'Under 750K' },
  { value: 'u1000', label: 'Under 1M' },
  { value: 'o50', label: 'Over 50K' },
  { value: 'o100', label: 'Over 100K' },
  { value: 'o200', label: 'Over 200K' },
  { value: 'o300', label: 'Over 300K' },
  { value: 'o400', label: 'Over 400K' },
  { value: 'o500', label: 'Over 500K' },
  { value: 'o750', label: 'Over 750K' },
  { value: 'o1000', label: 'Over 1M' },
  { value: 'o2000', label: 'Over 2M' },
  { value: '100to500', label: '100K to 500K' },
  { value: '100to1000', label: '100K to 1M' },
  { value: '500to1000', label: '500K to 1M' },
  { value: '500to10000', label: '500K to 10M' },
]

export { xys, sizes, colors, indexes, sectors, industries, marketCaps, averageVolumes }
